import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import EmptyStates from '../../../common/components/empty-states';
import styles from './no-search-results.scss';

const NoSearchResults: React.FC = () => {
  const { t } = useTranslation();

  return (
    <EmptyStates
      className={styles.container}
      title={t('no-search-results.no-results-found-title')}
      content={t('no-search-results.try-again')}
    />
  );
};

export default NoSearchResults;
